"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _withSizePresets = _interopRequireDefault(require("./withSizePresets"));
/* eslint-disable max-len */

var ChevronLeft = function ChevronLeft(props) {
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, (0, _extends2["default"])({
    viewBox: "0 0 20 24"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "back arrow gray"), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5,5.96834607 L5,5 L19.5008288,5 L19.5008288,6.93669214 L6.92566338,6.93669214 L6.92566338,19.5397311 L5,19.5397311 L5,5.96834607 Z",
    transform: "translate(12.250414, 12.269866) rotate(-45.000000) translate(-12.250414, -12.269866) "
  })));
};
var _default = (0, _withSizePresets["default"])(15, 15)(ChevronLeft);
exports["default"] = _default;
//# sourceMappingURL=ChevronLeft.js.map